import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import {isLoggedIn} from '../utils/auth'
import {Header} from 'components/Header/Header'


const Layout = ({ children, data }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Sample' },
            { name: 'keywords', content: 'sample, something' },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header
            title={data.site.siteMetadata.title}
            onCreateAccount={() => {}}
            onLogin={function noRefCheck() {}}
            onLogout={function noRefCheck() {}}
            userStatus={isLoggedIn()}
        />
        <div className='bg-gray-50 dark:bg-primary'>
            {children}
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
